import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { planBuilderQuantityUpdated } from '../../../actions/PlanBuilderActions';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useEligibleBreezeProducts } from '../../../hooks/useEligibleBreezeProducts';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { isUngatedForHubSpotCreditsSelector } from '../../../selectors/GatingSelectors';
import { planBuilderEligibleAddonsSelector, planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { currentSkuIdForProductSelector, productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import { trackPlanBuilderInteraction } from '../../../utils/tracking/trackingEventUtils';
import { FlushedTitle } from '../SharedComponents';
import ExpandableChecklist from './ExpandableChecklist';
import { jsx as _jsx } from "react/jsx-runtime";
const AddonsPickerList = ({
  defaultOpen = false
}) => {
  const dispatch = useAppDispatch();
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const apiNames = useAppSelector(state => {
    return productConfigurations.map(product => {
      return productForSkuIdSelector(state, {
        skuId: product.skuId
      }).apiName;
    });
  });
  const isAppReady = useGlobalLoading();
  const eligibleAddOnsSkuIds = useAppSelector(state => {
    if (!isAppReady) {
      return [];
    }
    const eligibleAddons = planBuilderEligibleAddonsSelector(state);
    return (eligibleAddons === null || eligibleAddons === void 0 ? void 0 : eligibleAddons.skuIds) || [];
  });
  const isUngatedForHubSpotCredits = useAppSelector(isUngatedForHubSpotCreditsSelector);
  /**
   * @temporary TODO: This should be removed once hubspot credits is live
   * @expiration 2025-09-15
   * @deprecated
   */
  const {
    eligibleBreezeApiNames
  } = useEligibleBreezeProducts({
    apiNames,
    skip: isUngatedForHubSpotCredits
  });
  const eligibleBreezeSkuIds = useAppSelector(state => {
    if (!isAppReady || !eligibleBreezeApiNames) {
      return [];
    }
    return eligibleBreezeApiNames.reduce((acc, apiName) => {
      const skuId = currentSkuIdForProductSelector(state, {
        apiName
      });
      if (skuId) {
        acc.push(skuId);
      }
      return acc;
    }, []);
  });
  const eligibleSkuIds = [...eligibleBreezeSkuIds, ...eligibleAddOnsSkuIds];
  const updateSelectedSkus = ({
    value,
    skuId,
    apiName,
    previousValue
  }) => {
    dispatch(planBuilderQuantityUpdated({
      skuId,
      quantity: value
    }));
    trackPlanBuilderInteraction({
      component: 'AddonsAndServicesPickerList',
      // this is named AddonsAndServicesPickerList to preserve historical tracking
      action: value > previousValue ? 'added item' : 'removed item',
      skuId,
      productName: apiName
    });
  };
  const trackAccordionInteraction = (use, isAccordionOpen) => {
    trackPlanBuilderInteraction({
      component: 'AddonsAndServicesPickerList',
      // this is named AddonsAndServicesPickerList to preserve historical tracking
      action: isAccordionOpen ? `opened ${use}` : `closed ${use}`
    });
  };
  if (!isAppReady || eligibleSkuIds.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ExpandableChecklist, {
    title: /*#__PURE__*/_jsx(FlushedTitle, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.addonsAndServices.addons.title"
      })
    }),
    subtext: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.addonsAndServices.addons.text"
      })
    }),
    skuIds: eligibleSkuIds,
    use: "addons",
    onSelectedChange: updateSelectedSkus,
    trackAccordionInteraction: trackAccordionInteraction,
    defaultOpen: defaultOpen
  });
};
export default AddonsPickerList;